<template>
    <section class="chat chat-empty">
        <div class="chat-empty__container">

            <font-awesome-icon icon="comment" />
            <p>Выберите чат или <span @click="newChat()">создайте новый</span></p>
        </div>
    </section>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faComment } from '@fortawesome/free-solid-svg-icons'

library.add(faComment)

export default {
    name: 'ChatEmpty',
    methods: {
        newChat() {
            this.$store.dispatch('changeState', {element: 'new_chat', val: true})
        }
    }
}

</script>